"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicLayout = exports.getPublicLayouts = exports.deleteLayoutRelation = exports.postLayoutRelation = exports.putLayoutOrganization = exports.putLayoutAccessibility = exports.deleteLayoutPermission = exports.postLayoutPermission = exports.putLayoutAction = exports.delLayout = exports.postLayout = exports.putLayout = exports.getLayout = exports.getLayouts = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var layoutsAuthorizedPath = root_1.cmsAuthorized + '/layouts/';
var layoutsPublicPath = root_1.cmsPublic + '/layouts/';

var getLayouts = function getLayouts(authentication, queryParameters) {
  return common_1.get(authentication, layoutsAuthorizedPath, queryParameters);
};

exports.getLayouts = getLayouts;

var getLayout = function getLayout(authentication, id) {
  return common_1.get(authentication, layoutsAuthorizedPath + id);
};

exports.getLayout = getLayout;

var putLayout = function putLayout(authentication, layout) {
  return common_1.put(authentication, layoutsAuthorizedPath + layout.id, layout);
};

exports.putLayout = putLayout;

var postLayout = function postLayout(authentication, layout) {
  return common_1.post(authentication, layoutsAuthorizedPath, layout);
};

exports.postLayout = postLayout;

var delLayout = function delLayout(authentication, id) {
  return common_1.del(authentication, layoutsAuthorizedPath + id);
};

exports.delLayout = delLayout;

var putLayoutAction = function putLayoutAction(authentication, id, action, data) {
  return common_1.putSub(authentication, layoutsAuthorizedPath, id, action, data);
};

exports.putLayoutAction = putLayoutAction;

var postLayoutPermission = function postLayoutPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, layoutsAuthorizedPath, id, permission);
};

exports.postLayoutPermission = postLayoutPermission;

var deleteLayoutPermission = function deleteLayoutPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, layoutsAuthorizedPath, id, permissionId);
};

exports.deleteLayoutPermission = deleteLayoutPermission;

var putLayoutAccessibility = function putLayoutAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, layoutsAuthorizedPath, id, accessibility);
};

exports.putLayoutAccessibility = putLayoutAccessibility;

var putLayoutOrganization = function putLayoutOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, layoutsAuthorizedPath, id, organizationId);
};

exports.putLayoutOrganization = putLayoutOrganization;

var postLayoutRelation = function postLayoutRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, layoutsAuthorizedPath, id, relation);
};

exports.postLayoutRelation = postLayoutRelation;

var deleteLayoutRelation = function deleteLayoutRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, layoutsAuthorizedPath, id, relationId);
};

exports.deleteLayoutRelation = deleteLayoutRelation;

var getPublicLayouts = function getPublicLayouts(authentication, queryParameters) {
  return common_1.get(authentication, layoutsPublicPath, queryParameters);
};

exports.getPublicLayouts = getPublicLayouts;

var getPublicLayout = function getPublicLayout(authentication, id) {
  return common_1.get(authentication, layoutsPublicPath + id);
};

exports.getPublicLayout = getPublicLayout;